export const PATHS = {
    authCallback: 'auth-callback',
    signupComplete: 'signup-complete',
    activity: 'activity',
    bookings: 'bookings',
    customers: 'customers',
    diary: 'bookings/diary',
    inbox: 'messages',
    management: 'management',
    messages: 'messages',
    orders: 'orders',
    profile: 'profile',
    reports: 'reports',
    vouchers: 'vouchers',
}
